import {
  CashbackRewardIcon,
  DiscountRewardIcon,
  PointRewardIcon,
  FreeShippingRewardIcon,
  StampsRewardIcon,
  FreeItemRewardIcon,
} from "../../../assets/svg";
import { RewardRuleEffects } from "../../../types";
import { Tooltip } from "@mui/material";

interface IProps {
  rewardType: RewardRuleEffects;
  text: string;
}

export const RewardTypeIcon = ({ rewardType, text }: IProps) => {
  return (
    <Tooltip
      arrow
      title={text}
      slotProps={{
        popper: {
          sx: {
            [`& .MuiTooltip-tooltip`]: {
              backgroundColor: "#FFF2F1",
              color: "#0F0F10", // Optional: change text color if needed
              fontSize: 12,
              border: "1px solid #FFC8C5",
            },
            [`& .MuiTooltip-arrow`]: {
              color: "#FFF2F1", // arrow color matches tooltip background
            },
          },
        },
      }}
    >
      <div className="icon-wrapper trans cursor-pointer inline-flex items-center justify-center min-w-8 h-8 rounded-full bg-py_green_1-300 hover:bg-primary-500">
        {rewardType === RewardRuleEffects.AddDiscount && <DiscountRewardIcon />}
        {rewardType === RewardRuleEffects.AddFreeItem && <FreeItemRewardIcon />}
        {rewardType === RewardRuleEffects.AddPoints && <PointRewardIcon />}
        {rewardType === RewardRuleEffects.Points && <StampsRewardIcon />}
        {rewardType === RewardRuleEffects.Points && <PointRewardIcon />}
        {rewardType === RewardRuleEffects.CashBack && <CashbackRewardIcon />}
        {rewardType === RewardRuleEffects.Shipping && (
          <FreeShippingRewardIcon />
        )}
      </div>
    </Tooltip>
  );
};
